module.exports = __webpack_public_path__ + "static/Airtable-cf523a3f84a39ef52389daeec976625d.jpg";